module.exports = __webpack_public_path__ + "img/imgstep6.d6845aa3.svg";